import request from '@/utils/request'

// 查询高端品牌培育管理列表
export function listGdpy(query) {
  return request({
    url: '/web/zlts/gdpy/list',
    method: 'get',
    params: query
  })
}

// 查询高端品牌培育管理详细
export function getGdpy(recid) {
  return request({
    url: '/web/zlts/gdpy/' + recid,
    method: 'get'
  })
}
